// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Validation Wrapper to position icon inside or next to input */
.validation-icon-wrapper {
  display: flex;
  align-items: center;
  margin-right: -4px;
  /* Adjust spacing */
}

/* Validation Buttons and Styles */
.validate-option-btn {
  background: transparent;
  border: none;
  color: #ffb74d;
  /* Amber/Yellow for action */
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.validate-option-btn:hover {
  transform: scale(1.1);
  color: #ff9800;
}

.validate-option-btn.loading {
  animation: spin 1s linear infinite;
  cursor: wait;
}

.validate-option-btn.success {
  color: #00e676;
  /* Green */
  cursor: default;
}

.validate-option-btn.error {
  color: #ff5252;
  /* Red */
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.ballot-option-edit-item {
  flex-wrap: wrap;
  /* Allow wrapping for validation message */
}

.option-validation-error {
  flex-basis: 100%;
  /* Force new line */
  margin-top: 4px;
  margin-left: 28px;
  /* Indent to align with text */
  padding: 8px 12px;
  background: rgba(255, 82, 82, 0.1);
  border: 1px solid rgba(255, 82, 82, 0.3);
  border-radius: 6px;
  color: #ff8a80;
  font-size: 12px;
}

.option-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.option-suggestion-pill {
  padding: 4px 10px;
  background: rgba(74, 144, 226, 0.15);
  border: 1px solid rgba(74, 144, 226, 0.3);
  border-radius: 99px;
  color: #90caf9;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s;
}

.option-suggestion-pill:hover {
  background: rgba(74, 144, 226, 0.25);
  border-color: rgba(74, 144, 226, 0.5);
  color: #fff;
}

/* Chatbot Icon Container */
.chatbot-icon-container {
  position: fixed;
  right: 20px;
  bottom: 140px;
  /* Positioned above ScrollNav (which is at bottom: 90px + 40px height = 130px, so 140px gives proper spacing) */
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Chatbot Icon Button */
.chatbot-icon-btn {
  background: linear-gradient(135deg, #00e0c5, #008080);
  border-radius: 50%;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 224, 197, 0.25);
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  animation: fadeIn 0.4s ease;
  opacity: 0.55;
}

.chatbot-icon-btn:hover {
  transform: translateY(-6px) scale(1.05);
  box-shadow: 0 10px 24px rgba(0, 224, 197, 0.45);
  opacity: 1;
}

.chatbot-icon-btn:active {
  transform: scale(0.95);
}

.chatbot-icon-btn:focus {
  outline: 3px solid rgba(0, 224, 197, 0.5);
  outline-offset: 4px;
}

.chatbot-icon {
  width: 20px;
  height: 20px;
  color: #fff;
}

/* Chatbot Overlay */
.chatbot-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  /* let sidebar/right show; middle is covered by screen */
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

/* Chatbot Screen */
.chatbot-screen {
  position: absolute;
  /* Align with middleContainer: margin-left:22%, width:46%, margin-top:14vh */
  top: 14vh;
  left: 22%;
  width: 46%;
  height: calc(100vh - 16vh);
  max-width: none;
  max-height: none;
  background: #071414;
  border-radius: 16px;
  border: 1px solid rgba(0, 224, 197, 0.15);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

.chatbot-page-screen {
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: calc(100vh - 16vh) !important;
  max-width: 100% !important;
  border-radius: 16px !important;
  animation: fadeIn 0.25s ease !important;
}

/* Chatbot Header */
.chatbot-header {
  background: linear-gradient(135deg, #091e1d, #071414);
  color: #ffffff;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 5;
  border-bottom: 1px solid rgba(0, 224, 197, 0.2);
}

.chatbot-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.chatbot-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chatbot-clear-btn {
  background: transparent;
  border: none;
  color: #b2ebf2;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
}

.chatbot-clear-btn:hover {
  text-decoration: underline;
}

.chatbot-close-btn {
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s ease;
}

.chatbot-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.close-icon {
  width: 24px;
  height: 24px;
}

/* Chatbot Body */
.chatbot-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  /* Make the entire first screen (header + 3 questions + future content) scrollable,
     just like the Figma. */
  overflow-y: auto;
  background: radial-gradient(circle at bottom, #0c2020, #071414);
}

/* Trending / hot topics (top section, like Figma first screen) */
.chatbot-trending {
  padding: 16px 20px 8px 20px;
  background: radial-gradient(circle at top left, #0f3b46, #02060b 55%, #000000);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.chatbot-trending-header {
  margin-bottom: 12px;
}

.chatbot-trending-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}

.chatbot-trending-subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.chatbot-trending-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chatbot-trending-item {
  border: none;
  outline: none;
  border-radius: 999px;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chatbot-trending-item:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.16);
  transform: translateY(-1px);
}

.chatbot-trending-item:active:not(:disabled) {
  transform: translateY(0);
}

.chatbot-trending-item:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.chatbot-trending-placeholder {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.trending-skeleton {
  height: 32px;
  border-radius: 999px;
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 0.08),
      rgba(255, 255, 255, 0.18),
      rgba(255, 255, 255, 0.08));
  background-size: 200% 100%;
  animation: skeleton-loading 1.2s ease-in-out infinite;
}

.chatbot-messages {
  flex: 1 1;
  padding: 16px 20px 20px 20px;
}

.chatbot-message {
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 12px;
  max-width: 80%;
  word-wrap: break-word;
}

.bot-message {
  background: linear-gradient(135deg, rgba(0, 224, 197, 0.12), rgba(0, 128, 128, 0.04));
  border: 1px solid rgba(0, 224, 197, 0.2);
  color: #ffffff;
  align-self: flex-start;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.bot-message.has-ballots {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  max-width: 100%;
}

.bot-message p {
  color: #ffffff !important;
  font-weight: 500;
}

.user-message {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  align-self: flex-end;
  margin-left: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.chatbot-message p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: inherit;
}

/* Ballot styling */
.ballot-container {
  margin-top: 12px;
  padding: 16px 18px;
  background: #262a2f;
  /* card-style like Figma */
  border-radius: 10px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.ballot-container.selected {
  background: #273533;
  border-color: rgba(0, 224, 197, 0.8);
  box-shadow: 0 4px 12px rgba(0, 224, 197, 0.25);
}

.ballot-container.sub-ballot {
  background: #1f2528;
  border-color: rgba(0, 224, 197, 0.4);
}

.ballot-container.editing {
  background: #1e2225;
  border-color: rgba(0, 224, 197, 0.5);
  padding: 20px;
}

.ballot-title {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
}

.ballot-sub-label {
  display: inline-block;
  margin-bottom: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(0, 224, 197, 0.12);
  border: 1px solid rgba(0, 224, 197, 0.6);
  color: #00e0c5;
  font-size: 11px;
  font-weight: 600;
}

.ballot-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 10px;
}

.ballot-option {
  position: relative;
  padding-left: 14px;
  font-size: 13px;
  color: #e0e0e0;
}

.ballot-option::before {
  content: "•";
  position: absolute;
  left: 0;
  top: 0;
  color: #00e0c5;
}

.ballot-keep-btn {
  margin-top: 12px;
  margin-left: auto;
  /* align to the right, like in Figma */
  padding: 6px 14px;
  background: rgba(0, 0, 0, 0.35);
  color: #00e0c5;
  border: 1px solid rgba(0, 224, 197, 0.8);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  width: auto;
  text-align: center;
}

.ballot-keep-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.35);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.ballot-keep-btn:active:not(:disabled) {
  transform: translateY(0);
}

.ballot-keep-btn.selected {
  background: rgba(76, 175, 80, 0.4);
  border-color: rgba(76, 175, 80, 0.8);
  color: #c8e6c9;
  font-weight: 700;
}

.ballot-keep-btn.selected:hover {
  background: rgba(76, 175, 80, 0.5);
  border-color: rgba(76, 175, 80, 1);
}

.ballot-keep-btn.saved {
  background: rgba(76, 175, 80, 0.3);
  border-color: rgba(76, 175, 80, 0.6);
  color: #a5d6a7;
  cursor: not-allowed;
  opacity: 0.7;
}

.ballot-keep-btn.saved:hover {
  transform: none;
  box-shadow: none;
}

.ballot-container.saved {
  background: linear-gradient(145deg, #1e2a24 0%, #161c20 100%);
  border-color: rgba(76, 175, 80, 0.6);
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.ballot-saved-badge-overlay {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(76, 175, 80, 0.2);
  color: #81c784;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid rgba(76, 175, 80, 0.5);
  display: flex;
  align-items: center;
  gap: 4px;
  pointer-events: none;
  animation: fadeIn 0.3s ease;
}

.ballot-saved-badge-overlay svg {
  width: 12px;
  height: 12px;
}

/* Editable Ballot Styles */
.ballot-edit-section {
  margin-bottom: 20px;
}

.ballot-edit-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 8px;
}

.ballot-edit-input {
  width: 100%;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.ballot-edit-input:focus {
  border-color: #00e0c5;
}

.ballot-edit-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.ballot-edit-input[readonly],
.ballot-option-edit-input[readonly] {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
}


.ballot-options-edit {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.ballot-option-edit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
  padding: 8px;
  margin: -8px;
  border-radius: 8px;
  cursor: default;
}

.ballot-option-edit-item.dragging {
  opacity: 0.5;
  background: rgba(0, 224, 197, 0.1);
}

.ballot-option-edit-item.drag-over {
  background: rgba(0, 224, 197, 0.15);
  border: 2px dashed #00e0c5;
  margin: -10px;
  padding: 6px;
}

/* Drag Handle */
.drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: rgba(255, 255, 255, 0.4);
  cursor: grab;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.drag-handle:hover {
  color: #00e0c5;
  background: rgba(0, 224, 197, 0.1);
}

.drag-handle:active {
  cursor: grabbing;
  color: #00e0c5;
}

.option-letter {
  color: #00e0c5;
  font-weight: 600;
  font-size: 14px;
  min-width: 20px;
}

.ballot-option-edit-input {
  flex: 1 1;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
}

.ballot-option-edit-input:focus {
  border-color: #00e0c5;
}

.ballot-option-edit-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.remove-option-btn {
  background: transparent;
  border: none;
  color: #ff4444;
  font-size: 24px;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
}

.remove-option-btn:hover {
  background: rgba(255, 68, 68, 0.1);
  transform: scale(1.1);
}

.add-option-btn {
  align-self: flex-start;
  background: rgba(0, 224, 197, 0.1);
  border: 1px solid #00e0c5;
  color: #00e0c5;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.add-option-btn:hover {
  background: rgba(0, 224, 197, 0.2);
}

/* Media Upload Styles */
.ballot-media-upload {
  width: 100%;
  min-height: 150px;
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.05);
}

.ballot-media-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 30px;
  text-align: center;
}

.media-icon {
  font-size: 36px;
}

.ballot-media-placeholder p {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
}

.media-hint {
  font-size: 11px !important;
  color: rgba(255, 255, 255, 0.5) !important;
}

.choose-media-btn {
  background: rgba(0, 224, 197, 0.1);
  border: 1px solid #00e0c5;
  color: #00e0c5;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s ease;
  margin-top: 8px;
}

.choose-media-btn:hover {
  background: rgba(0, 224, 197, 0.2);
}

.ballot-media-preview {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ballot-media-preview img {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 8px;
}

.ballot-media-preview video {
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
}

.file-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px;
}

.file-icon {
  font-size: 48px;
}

.file-name {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  word-break: break-all;
  text-align: center;
  max-width: 200px;
}

.remove-media-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: white;
  font-size: 20px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
  line-height: 1;
}

.remove-media-btn:hover {
  background: rgba(0, 0, 0, 0.9);
}

.ballot-edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.cancel-edit-btn,
.save-ballot-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.cancel-edit-btn {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.cancel-edit-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.save-ballot-btn {
  background: #00e0c5;
  color: #000;
}

.save-ballot-btn:hover {
  background: #00c9b0;
}

/* Sub-ballot prompt */
.subballot-prompt {
  margin-top: 16px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.subballot-question {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #ffffff;
}

.subballot-actions {
  display: flex;
  gap: 8px;
}

.subballot-btn {
  flex: 1 1;
  padding: 8px 0;
  border-radius: 999px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.subballot-btn.yes {
  background: #00e0c5;
  color: #000;
}

.subballot-btn.yes:hover {
  background: #00c9b0;
}

.subballot-btn.no {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.subballot-btn.no:hover {
  background: rgba(255, 255, 255, 0.2);
}

.loading-message {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loading-dots {
  display: flex;
  gap: 4px;
}

.loading-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.7);
  animation: bounce 1.4s infinite ease-in-out both;
}

.loading-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

/* Chatbot Input Container */
.chatbot-input-container {
  padding: 16px;
  background: #091e1d;
  border-top: 1px solid rgba(0, 224, 197, 0.2);
  display: flex;
  gap: 10px;
}

.chatbot-input {
  flex: 1 1;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 24px;
  font-size: 14px;
  color: #ffffff;
  outline: none;
  transition: all 0.2s ease;
}

.chatbot-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.chatbot-input:focus {
  border-color: #00e0c5;
  box-shadow: 0 0 8px rgba(0, 224, 197, 0.25);
}

.chatbot-send-btn {
  padding: 12px 24px;
  background: linear-gradient(135deg, #00e0c5, #008080);
  color: #071414;
  border: none;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.chatbot-send-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 224, 197, 0.4);
}

.chatbot-send-btn:active {
  transform: translateY(0);
}

.chatbot-send-btn:disabled {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.3);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

/* ========== Unified Sub-Ballots Container ========== */
.sub-ballots-unified-container {
  margin-top: 16px;
  background: linear-gradient(145deg, #1a1f24 0%, #141920 100%);
  border-radius: 16px;
  border: 1px solid rgba(0, 224, 197, 0.3);
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.sub-ballots-unified-container.saved {
  border-color: rgba(76, 175, 80, 0.5);
  background: linear-gradient(145deg, #1a2420 0%, #14191a 100%);
}

/* Header */
.sub-ballots-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: rgba(0, 224, 197, 0.08);
  border-bottom: 1px solid rgba(0, 224, 197, 0.2);
}

.sub-ballots-title {
  font-size: 16px;
  font-weight: 600;
  color: #00e0c5;
}

.sub-ballots-edit-btn {
  background: rgba(0, 224, 197, 0.1);
  border: 1px solid rgba(0, 224, 197, 0.4);
  color: #00e0c5;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.sub-ballots-edit-btn:hover {
  background: rgba(0, 224, 197, 0.2);
  border-color: #00e0c5;
  transform: scale(1.05);
}

.sub-ballots-saved-badge {
  background: rgba(76, 175, 80, 0.2);
  color: #81c784;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid rgba(76, 175, 80, 0.4);
}

/* Sub-Ballots List */
.sub-ballots-list {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
}

/* Sub-Ballot Card (View Mode) */
.sub-ballot-card {
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px;
  transition: all 0.2s ease;
}

.sub-ballot-card:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(0, 224, 197, 0.3);
}

.sub-ballot-card.saved {
  border-color: rgba(76, 175, 80, 0.4);
  opacity: 0.85;
}

.sub-ballot-card-header {
  margin-bottom: 10px;
}

.sub-ballot-number {
  font-size: 11px;
  font-weight: 700;
  color: #00e0c5;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sub-ballot-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
  line-height: 1.4;
}

.sub-ballot-card-options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sub-ballot-card-option {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  padding-left: 14px;
  position: relative;
}

.sub-ballot-card-option::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #00e0c5;
}

/* Sub-Ballot Edit Card */
.sub-ballot-edit-card {
  background: rgba(0, 224, 197, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(0, 224, 197, 0.3);
  padding: 16px;
}

.sub-ballot-edit-header {
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sub-ballot-edit-section {
  margin-bottom: 14px;
}

.sub-ballot-edit-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.sub-ballot-edit-input {
  width: 100%;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.sub-ballot-edit-input:focus {
  border-color: #00e0c5;
  background: rgba(0, 224, 197, 0.05);
}

.sub-ballot-options-edit {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}

.sub-ballot-option-edit-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
  margin: -6px;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: default;
}

.sub-ballot-option-edit-item.dragging {
  opacity: 0.5;
  background: rgba(0, 224, 197, 0.1);
}

.sub-ballot-option-edit-item.drag-over {
  background: rgba(0, 224, 197, 0.15);
  border: 2px dashed #00e0c5;
  margin: -8px;
  padding: 4px;
}

.sub-ballot-option-edit-input {
  flex: 1 1;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: white;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s ease;
}

.sub-ballot-option-edit-input:focus {
  border-color: #00e0c5;
}

.add-option-btn.small {
  padding: 6px 12px;
  font-size: 12px;
}

/* Sub-Ballots Footer */
.sub-ballots-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.sub-ballots-cancel-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sub-ballots-cancel-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.sub-ballots-save-btn {
  background: linear-gradient(135deg, #00e0c5 0%, #00b8a0 100%);
  border: none;
  color: #000;
  padding: 12px 28px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 16px rgba(0, 224, 197, 0.3);
}

.sub-ballots-save-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 224, 197, 0.4);
}

.sub-ballots-save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* ========== End Unified Sub-Ballots Container ========== */

/* ========== Location Autocomplete Styles ========== */

.ballot-edit-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.ballot-edit-label-row .ballot-edit-label {
  margin-bottom: 0;
}

.auto-detect-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 224, 197, 0.1);
  border: 1px solid rgba(0, 224, 197, 0.4);
  color: #00e0c5;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.auto-detect-btn:hover:not(:disabled) {
  background: rgba(0, 224, 197, 0.2);
  border-color: #00e0c5;
  transform: translateY(-1px);
}

.auto-detect-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.gps-icon {
  width: 14px;
  height: 14px;
}

.detecting-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(0, 224, 197, 0.3);
  border-top-color: #00e0c5;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.location-input-wrapper {
  position: relative;
  width: 100%;
}

.location-input {
  padding-right: 36px !important;
}

.location-clear-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  line-height: 1;
}

.location-clear-btn:hover {
  background: rgba(255, 68, 68, 0.2);
  color: #ff6b6b;
}

.location-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 4px 0 0 0;
  padding: 0;
  list-style: none;
  background: #1e2225;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  max-height: 200px;
  overflow-y: auto;
  z-index: 100;
}

.location-suggestion-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.15s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.location-suggestion-item:last-child {
  border-bottom: none;
}

.location-suggestion-item:hover {
  background: rgba(0, 224, 197, 0.1);
}

.location-pin-icon {
  color: #00e0c5;
  flex-shrink: 0;
}

.location-suggestion-item span {
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  line-height: 1.4;
}

.location-parsed-details {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.location-detail-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  background: rgba(0, 224, 197, 0.1);
  border: 1px solid rgba(0, 224, 197, 0.3);
  border-radius: 16px;
  color: #00e0c5;
  font-size: 11px;
  font-weight: 500;
}

/* ========== End Location Autocomplete Styles ========== */

/* Responsive */
@media (max-width: 768px) {
  .chatbot-screen {
    width: 95%;
    height: 85%;
    max-height: none;
  }

  .chatbot-icon-container {
    bottom: 90px;
  }
}

/* Chatbot Sidebar Styles */
.chatbot-menu-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
  margin-right: 12px;
}

.chatbot-menu-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.chatbot-sidebar {
  position: absolute;
  top: 64px;
  /* Approximate header height */
  left: 0;
  bottom: 0;
  width: 260px;
  background: #071414;
  border-right: 1px solid rgba(0, 224, 197, 0.2);
  z-index: 20;
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  transform: translateX(-100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.chatbot-sidebar.open {
  transform: translateX(0);
}

.chatbot-sidebar-backdrop {
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  z-index: 18;
  animation: fadeIn 0.25s ease;
}

@keyframes slideRight {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.new-chat-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 24px;
}

.new-chat-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.chatbot-history-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}

.history-section-title {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-left: 8px;
}

.history-loading {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  margin-top: 20px;
}

.history-item {
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.history-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.history-item.active {
  background: rgba(0, 224, 197, 0.15);
  border-left: 3px solid #00e0c5;
}

.history-item-title {
  font-size: 14px;
  color: #e0e0e0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

.history-item-date {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
}

/* Scrollbar for sidebar */
.chatbot-sidebar::-webkit-scrollbar {
  width: 5px;
}

.chatbot-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.chatbot-sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}

/* Generating Sub-Ballots Animation */
.subballot-generating {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(0, 224, 197, 0.2);
  margin-top: 16px;
  animation: fadeIn 0.4s ease;
}

.generating-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(0, 224, 197, 0.3);
  border-radius: 50%;
  border-top-color: #00e0c5;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

.subballot-generating p {
  color: #00e0c5;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.7;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.7;
  }
}


/* Generating Sub-Ballots Animation */
.subballot-generating {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(0, 224, 197, 0.2);
  margin-top: 16px;
  animation: fadeIn 0.4s ease;
}

.generating-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(0, 224, 197, 0.3);
  border-radius: 50%;
  border-top-color: #00e0c5;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

.subballot-generating p {
  color: #00e0c5;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0% {
    opacity: 0.7;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.7;
  }
}

/* Validation Save Error Message */
.ballot-edit-actions-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.save-error-message {
  color: #ff5252;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  background: rgba(255, 82, 82, 0.1);
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid rgba(255, 82, 82, 0.2);
  width: 100%;
  animation: fadeIn 0.3s ease;
}

.spin {
  animation: spin 1s linear infinite;
}

.validate-option-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  pointer-events: none;
}

.validate-option-status.loading {
  color: #00e0c5;
}

.validate-option-status.success {
  color: #4caf50;
}

.validate-option-status.error {
  color: #f44336;
}`, "",{"version":3,"sources":["webpack://./src/Components/Chatbot/Chatbot.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,+GAA+G;EAC/G,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,qDAAqD;EACrD,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,wDAAwD;EACxD,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,4EAA4E;EAC5E,SAAS;EACT,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB;2BACyB;EACzB,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA,iEAAiE;AACjE;EACE,2BAA2B;EAC3B,8EAA8E;EAC9E,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB;;;gCAG8B;EAC9B,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,SAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qFAAqF;EACrF,wCAAwC;EACxC,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,oCAAoC;EACpC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;EAC/B,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,aAAa;EACb,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,6DAA6D;AAC/D;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,mCAAmC;EACnC,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,4DAA4D;;AAE5D,uDAAuD;;AAEvD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D,eAAe;AACf;EACE;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,OAAO;EACP,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;EAC9C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;;AAGA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Validation Wrapper to position icon inside or next to input */\n.validation-icon-wrapper {\n  display: flex;\n  align-items: center;\n  margin-right: -4px;\n  /* Adjust spacing */\n}\n\n/* Validation Buttons and Styles */\n.validate-option-btn {\n  background: transparent;\n  border: none;\n  color: #ffb74d;\n  /* Amber/Yellow for action */\n  font-size: 16px;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.validate-option-btn:hover {\n  transform: scale(1.1);\n  color: #ff9800;\n}\n\n.validate-option-btn.loading {\n  animation: spin 1s linear infinite;\n  cursor: wait;\n}\n\n.validate-option-btn.success {\n  color: #00e676;\n  /* Green */\n  cursor: default;\n}\n\n.validate-option-btn.error {\n  color: #ff5252;\n  /* Red */\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ballot-option-edit-item {\n  flex-wrap: wrap;\n  /* Allow wrapping for validation message */\n}\n\n.option-validation-error {\n  flex-basis: 100%;\n  /* Force new line */\n  margin-top: 4px;\n  margin-left: 28px;\n  /* Indent to align with text */\n  padding: 8px 12px;\n  background: rgba(255, 82, 82, 0.1);\n  border: 1px solid rgba(255, 82, 82, 0.3);\n  border-radius: 6px;\n  color: #ff8a80;\n  font-size: 12px;\n}\n\n.option-suggestions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.option-suggestion-pill {\n  padding: 4px 10px;\n  background: rgba(74, 144, 226, 0.15);\n  border: 1px solid rgba(74, 144, 226, 0.3);\n  border-radius: 99px;\n  color: #90caf9;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.option-suggestion-pill:hover {\n  background: rgba(74, 144, 226, 0.25);\n  border-color: rgba(74, 144, 226, 0.5);\n  color: #fff;\n}\n\n/* Chatbot Icon Container */\n.chatbot-icon-container {\n  position: fixed;\n  right: 20px;\n  bottom: 140px;\n  /* Positioned above ScrollNav (which is at bottom: 90px + 40px height = 130px, so 140px gives proper spacing) */\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Chatbot Icon Button */\n.chatbot-icon-btn {\n  background: linear-gradient(135deg, #00e0c5, #008080);\n  border-radius: 50%;\n  border: none;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 20px rgba(0, 224, 197, 0.25);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n  animation: fadeIn 0.4s ease;\n  opacity: 0.55;\n}\n\n.chatbot-icon-btn:hover {\n  transform: translateY(-6px) scale(1.05);\n  box-shadow: 0 10px 24px rgba(0, 224, 197, 0.45);\n  opacity: 1;\n}\n\n.chatbot-icon-btn:active {\n  transform: scale(0.95);\n}\n\n.chatbot-icon-btn:focus {\n  outline: 3px solid rgba(0, 224, 197, 0.5);\n  outline-offset: 4px;\n}\n\n.chatbot-icon {\n  width: 20px;\n  height: 20px;\n  color: #fff;\n}\n\n/* Chatbot Overlay */\n.chatbot-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n  /* let sidebar/right show; middle is covered by screen */\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.3s ease;\n}\n\n/* Chatbot Screen */\n.chatbot-screen {\n  position: absolute;\n  /* Align with middleContainer: margin-left:22%, width:46%, margin-top:14vh */\n  top: 14vh;\n  left: 22%;\n  width: 46%;\n  height: calc(100vh - 16vh);\n  max-width: none;\n  max-height: none;\n  background: #071414;\n  border-radius: 16px;\n  border: 1px solid rgba(0, 224, 197, 0.15);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.65);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: slideUp 0.3s ease;\n}\n\n.chatbot-page-screen {\n  position: relative !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: calc(100vh - 16vh) !important;\n  max-width: 100% !important;\n  border-radius: 16px !important;\n  animation: fadeIn 0.25s ease !important;\n}\n\n/* Chatbot Header */\n.chatbot-header {\n  background: linear-gradient(135deg, #091e1d, #071414);\n  color: #ffffff;\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  border-bottom: 1px solid rgba(0, 224, 197, 0.2);\n}\n\n.chatbot-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.chatbot-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.chatbot-clear-btn {\n  background: transparent;\n  border: none;\n  color: #b2ebf2;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 4px 0;\n}\n\n.chatbot-clear-btn:hover {\n  text-decoration: underline;\n}\n\n.chatbot-close-btn {\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s ease;\n}\n\n.chatbot-close-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.close-icon {\n  width: 24px;\n  height: 24px;\n}\n\n/* Chatbot Body */\n.chatbot-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  /* Make the entire first screen (header + 3 questions + future content) scrollable,\n     just like the Figma. */\n  overflow-y: auto;\n  background: radial-gradient(circle at bottom, #0c2020, #071414);\n}\n\n/* Trending / hot topics (top section, like Figma first screen) */\n.chatbot-trending {\n  padding: 16px 20px 8px 20px;\n  background: radial-gradient(circle at top left, #0f3b46, #02060b 55%, #000000);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.chatbot-trending-header {\n  margin-bottom: 12px;\n}\n\n.chatbot-trending-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.chatbot-trending-subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.chatbot-trending-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.chatbot-trending-item {\n  border: none;\n  outline: none;\n  border-radius: 999px;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chatbot-trending-item:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.16);\n  transform: translateY(-1px);\n}\n\n.chatbot-trending-item:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.chatbot-trending-item:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.chatbot-trending-placeholder {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.trending-skeleton {\n  height: 32px;\n  border-radius: 999px;\n  background: linear-gradient(90deg,\n      rgba(255, 255, 255, 0.08),\n      rgba(255, 255, 255, 0.18),\n      rgba(255, 255, 255, 0.08));\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.2s ease-in-out infinite;\n}\n\n.chatbot-messages {\n  flex: 1;\n  padding: 16px 20px 20px 20px;\n}\n\n.chatbot-message {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  border-radius: 12px;\n  max-width: 80%;\n  word-wrap: break-word;\n}\n\n.bot-message {\n  background: linear-gradient(135deg, rgba(0, 224, 197, 0.12), rgba(0, 128, 128, 0.04));\n  border: 1px solid rgba(0, 224, 197, 0.2);\n  color: #ffffff;\n  align-self: flex-start;\n  font-weight: 500;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.bot-message.has-ballots {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  max-width: 100%;\n}\n\n.bot-message p {\n  color: #ffffff !important;\n  font-weight: 500;\n}\n\n.user-message {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  align-self: flex-end;\n  margin-left: auto;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.chatbot-message p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: inherit;\n}\n\n/* Ballot styling */\n.ballot-container {\n  margin-top: 12px;\n  padding: 16px 18px;\n  background: #262a2f;\n  /* card-style like Figma */\n  border-radius: 10px;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n}\n\n.ballot-container.selected {\n  background: #273533;\n  border-color: rgba(0, 224, 197, 0.8);\n  box-shadow: 0 4px 12px rgba(0, 224, 197, 0.25);\n}\n\n.ballot-container.sub-ballot {\n  background: #1f2528;\n  border-color: rgba(0, 224, 197, 0.4);\n}\n\n.ballot-container.editing {\n  background: #1e2225;\n  border-color: rgba(0, 224, 197, 0.5);\n  padding: 20px;\n}\n\n.ballot-title {\n  font-weight: 600;\n  margin-bottom: 8px;\n  font-size: 15px;\n}\n\n.ballot-sub-label {\n  display: inline-block;\n  margin-bottom: 6px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(0, 224, 197, 0.12);\n  border: 1px solid rgba(0, 224, 197, 0.6);\n  color: #00e0c5;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ballot-options {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 10px;\n}\n\n.ballot-option {\n  position: relative;\n  padding-left: 14px;\n  font-size: 13px;\n  color: #e0e0e0;\n}\n\n.ballot-option::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  color: #00e0c5;\n}\n\n.ballot-keep-btn {\n  margin-top: 12px;\n  margin-left: auto;\n  /* align to the right, like in Figma */\n  padding: 6px 14px;\n  background: rgba(0, 0, 0, 0.35);\n  color: #00e0c5;\n  border: 1px solid rgba(0, 224, 197, 0.8);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  width: auto;\n  text-align: center;\n}\n\n.ballot-keep-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.35);\n  border-color: rgba(255, 255, 255, 0.6);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.ballot-keep-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.ballot-keep-btn.selected {\n  background: rgba(76, 175, 80, 0.4);\n  border-color: rgba(76, 175, 80, 0.8);\n  color: #c8e6c9;\n  font-weight: 700;\n}\n\n.ballot-keep-btn.selected:hover {\n  background: rgba(76, 175, 80, 0.5);\n  border-color: rgba(76, 175, 80, 1);\n}\n\n.ballot-keep-btn.saved {\n  background: rgba(76, 175, 80, 0.3);\n  border-color: rgba(76, 175, 80, 0.6);\n  color: #a5d6a7;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.ballot-keep-btn.saved:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.ballot-container.saved {\n  background: linear-gradient(145deg, #1e2a24 0%, #161c20 100%);\n  border-color: rgba(76, 175, 80, 0.6);\n  position: relative;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.ballot-saved-badge-overlay {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: rgba(76, 175, 80, 0.2);\n  color: #81c784;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  border: 1px solid rgba(76, 175, 80, 0.5);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  pointer-events: none;\n  animation: fadeIn 0.3s ease;\n}\n\n.ballot-saved-badge-overlay svg {\n  width: 12px;\n  height: 12px;\n}\n\n/* Editable Ballot Styles */\n.ballot-edit-section {\n  margin-bottom: 20px;\n}\n\n.ballot-edit-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 8px;\n}\n\n.ballot-edit-input {\n  width: 100%;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.ballot-edit-input:focus {\n  border-color: #00e0c5;\n}\n\n.ballot-edit-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.ballot-edit-input[readonly],\n.ballot-option-edit-input[readonly] {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.7);\n  cursor: not-allowed;\n}\n\n\n.ballot-options-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.ballot-option-edit-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  transition: all 0.2s ease;\n  padding: 8px;\n  margin: -8px;\n  border-radius: 8px;\n  cursor: default;\n}\n\n.ballot-option-edit-item.dragging {\n  opacity: 0.5;\n  background: rgba(0, 224, 197, 0.1);\n}\n\n.ballot-option-edit-item.drag-over {\n  background: rgba(0, 224, 197, 0.15);\n  border: 2px dashed #00e0c5;\n  margin: -10px;\n  padding: 6px;\n}\n\n/* Drag Handle */\n.drag-handle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: rgba(255, 255, 255, 0.4);\n  cursor: grab;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.drag-handle:hover {\n  color: #00e0c5;\n  background: rgba(0, 224, 197, 0.1);\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n  color: #00e0c5;\n}\n\n.option-letter {\n  color: #00e0c5;\n  font-weight: 600;\n  font-size: 14px;\n  min-width: 20px;\n}\n\n.ballot-option-edit-input {\n  flex: 1;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.ballot-option-edit-input:focus {\n  border-color: #00e0c5;\n}\n\n.ballot-option-edit-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.remove-option-btn {\n  background: transparent;\n  border: none;\n  color: #ff4444;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px 8px;\n  line-height: 1;\n  transition: transform 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n}\n\n.remove-option-btn:hover {\n  background: rgba(255, 68, 68, 0.1);\n  transform: scale(1.1);\n}\n\n.add-option-btn {\n  align-self: flex-start;\n  background: rgba(0, 224, 197, 0.1);\n  border: 1px solid #00e0c5;\n  color: #00e0c5;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.add-option-btn:hover {\n  background: rgba(0, 224, 197, 0.2);\n}\n\n/* Media Upload Styles */\n.ballot-media-upload {\n  width: 100%;\n  min-height: 150px;\n  border: 2px dashed rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.ballot-media-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 30px;\n  text-align: center;\n}\n\n.media-icon {\n  font-size: 36px;\n}\n\n.ballot-media-placeholder p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 13px;\n}\n\n.media-hint {\n  font-size: 11px !important;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.choose-media-btn {\n  background: rgba(0, 224, 197, 0.1);\n  border: 1px solid #00e0c5;\n  color: #00e0c5;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s ease;\n  margin-top: 8px;\n}\n\n.choose-media-btn:hover {\n  background: rgba(0, 224, 197, 0.2);\n}\n\n.ballot-media-preview {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 150px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ballot-media-preview img {\n  max-width: 100%;\n  max-height: 300px;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.ballot-media-preview video {\n  max-width: 100%;\n  max-height: 300px;\n  border-radius: 8px;\n}\n\n.file-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 20px;\n}\n\n.file-icon {\n  font-size: 48px;\n}\n\n.file-name {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 14px;\n  word-break: break-all;\n  text-align: center;\n  max-width: 200px;\n}\n\n.remove-media-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.7);\n  border: none;\n  color: white;\n  font-size: 20px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s ease;\n  line-height: 1;\n}\n\n.remove-media-btn:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n\n.ballot-edit-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.cancel-edit-btn,\n.save-ballot-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.cancel-edit-btn {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.cancel-edit-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.save-ballot-btn {\n  background: #00e0c5;\n  color: #000;\n}\n\n.save-ballot-btn:hover {\n  background: #00c9b0;\n}\n\n/* Sub-ballot prompt */\n.subballot-prompt {\n  margin-top: 16px;\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.subballot-question {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  color: #ffffff;\n}\n\n.subballot-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.subballot-btn {\n  flex: 1;\n  padding: 8px 0;\n  border-radius: 999px;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.subballot-btn.yes {\n  background: #00e0c5;\n  color: #000;\n}\n\n.subballot-btn.yes:hover {\n  background: #00c9b0;\n}\n\n.subballot-btn.no {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.subballot-btn.no:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.loading-message {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.loading-dots {\n  display: flex;\n  gap: 4px;\n}\n\n.loading-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.7);\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.loading-dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.loading-dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n\n  40% {\n    transform: scale(1);\n  }\n}\n\n/* Chatbot Input Container */\n.chatbot-input-container {\n  padding: 16px;\n  background: #091e1d;\n  border-top: 1px solid rgba(0, 224, 197, 0.2);\n  display: flex;\n  gap: 10px;\n}\n\n.chatbot-input {\n  flex: 1;\n  padding: 12px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 24px;\n  font-size: 14px;\n  color: #ffffff;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.chatbot-input::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.chatbot-input:focus {\n  border-color: #00e0c5;\n  box-shadow: 0 0 8px rgba(0, 224, 197, 0.25);\n}\n\n.chatbot-send-btn {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #00e0c5, #008080);\n  color: #071414;\n  border: none;\n  border-radius: 24px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.chatbot-send-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 224, 197, 0.4);\n}\n\n.chatbot-send-btn:active {\n  transform: translateY(0);\n}\n\n.chatbot-send-btn:disabled {\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.3);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* ========== Unified Sub-Ballots Container ========== */\n.sub-ballots-unified-container {\n  margin-top: 16px;\n  background: linear-gradient(145deg, #1a1f24 0%, #141920 100%);\n  border-radius: 16px;\n  border: 1px solid rgba(0, 224, 197, 0.3);\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.sub-ballots-unified-container.saved {\n  border-color: rgba(76, 175, 80, 0.5);\n  background: linear-gradient(145deg, #1a2420 0%, #14191a 100%);\n}\n\n/* Header */\n.sub-ballots-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: rgba(0, 224, 197, 0.08);\n  border-bottom: 1px solid rgba(0, 224, 197, 0.2);\n}\n\n.sub-ballots-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #00e0c5;\n}\n\n.sub-ballots-edit-btn {\n  background: rgba(0, 224, 197, 0.1);\n  border: 1px solid rgba(0, 224, 197, 0.4);\n  color: #00e0c5;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.sub-ballots-edit-btn:hover {\n  background: rgba(0, 224, 197, 0.2);\n  border-color: #00e0c5;\n  transform: scale(1.05);\n}\n\n.sub-ballots-saved-badge {\n  background: rgba(76, 175, 80, 0.2);\n  color: #81c784;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  border: 1px solid rgba(76, 175, 80, 0.4);\n}\n\n/* Sub-Ballots List */\n.sub-ballots-list {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Sub-Ballot Card (View Mode) */\n.sub-ballot-card {\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 16px;\n  transition: all 0.2s ease;\n}\n\n.sub-ballot-card:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(0, 224, 197, 0.3);\n}\n\n.sub-ballot-card.saved {\n  border-color: rgba(76, 175, 80, 0.4);\n  opacity: 0.85;\n}\n\n.sub-ballot-card-header {\n  margin-bottom: 10px;\n}\n\n.sub-ballot-number {\n  font-size: 11px;\n  font-weight: 700;\n  color: #00e0c5;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.sub-ballot-card-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 12px;\n  line-height: 1.4;\n}\n\n.sub-ballot-card-options {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sub-ballot-card-option {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.8);\n  padding-left: 14px;\n  position: relative;\n}\n\n.sub-ballot-card-option::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: #00e0c5;\n}\n\n/* Sub-Ballot Edit Card */\n.sub-ballot-edit-card {\n  background: rgba(0, 224, 197, 0.05);\n  border-radius: 12px;\n  border: 1px solid rgba(0, 224, 197, 0.3);\n  padding: 16px;\n}\n\n.sub-ballot-edit-header {\n  margin-bottom: 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.sub-ballot-edit-section {\n  margin-bottom: 14px;\n}\n\n.sub-ballot-edit-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.sub-ballot-edit-input {\n  width: 100%;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.sub-ballot-edit-input:focus {\n  border-color: #00e0c5;\n  background: rgba(0, 224, 197, 0.05);\n}\n\n.sub-ballot-options-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.sub-ballot-option-edit-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px;\n  margin: -6px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  cursor: default;\n}\n\n.sub-ballot-option-edit-item.dragging {\n  opacity: 0.5;\n  background: rgba(0, 224, 197, 0.1);\n}\n\n.sub-ballot-option-edit-item.drag-over {\n  background: rgba(0, 224, 197, 0.15);\n  border: 2px dashed #00e0c5;\n  margin: -8px;\n  padding: 4px;\n}\n\n.sub-ballot-option-edit-input {\n  flex: 1;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  color: white;\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.sub-ballot-option-edit-input:focus {\n  border-color: #00e0c5;\n}\n\n.add-option-btn.small {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n/* Sub-Ballots Footer */\n.sub-ballots-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 20px;\n  background: rgba(0, 0, 0, 0.2);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.sub-ballots-cancel-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sub-ballots-cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.sub-ballots-save-btn {\n  background: linear-gradient(135deg, #00e0c5 0%, #00b8a0 100%);\n  border: none;\n  color: #000;\n  padding: 12px 28px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 16px rgba(0, 224, 197, 0.3);\n}\n\n.sub-ballots-save-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 224, 197, 0.4);\n}\n\n.sub-ballots-save-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ========== End Unified Sub-Ballots Container ========== */\n\n/* ========== Location Autocomplete Styles ========== */\n\n.ballot-edit-label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.ballot-edit-label-row .ballot-edit-label {\n  margin-bottom: 0;\n}\n\n.auto-detect-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(0, 224, 197, 0.1);\n  border: 1px solid rgba(0, 224, 197, 0.4);\n  color: #00e0c5;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.auto-detect-btn:hover:not(:disabled) {\n  background: rgba(0, 224, 197, 0.2);\n  border-color: #00e0c5;\n  transform: translateY(-1px);\n}\n\n.auto-detect-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.gps-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.detecting-spinner {\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(0, 224, 197, 0.3);\n  border-top-color: #00e0c5;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.location-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.location-input {\n  padding-right: 36px !important;\n}\n\n.location-clear-btn {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 16px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  line-height: 1;\n}\n\n.location-clear-btn:hover {\n  background: rgba(255, 68, 68, 0.2);\n  color: #ff6b6b;\n}\n\n.location-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 4px 0 0 0;\n  padding: 0;\n  list-style: none;\n  background: #1e2225;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 100;\n}\n\n.location-suggestion-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.location-suggestion-item:last-child {\n  border-bottom: none;\n}\n\n.location-suggestion-item:hover {\n  background: rgba(0, 224, 197, 0.1);\n}\n\n.location-pin-icon {\n  color: #00e0c5;\n  flex-shrink: 0;\n}\n\n.location-suggestion-item span {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.location-parsed-details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.location-detail-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  background: rgba(0, 224, 197, 0.1);\n  border: 1px solid rgba(0, 224, 197, 0.3);\n  border-radius: 16px;\n  color: #00e0c5;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n/* ========== End Location Autocomplete Styles ========== */\n\n/* Responsive */\n@media (max-width: 768px) {\n  .chatbot-screen {\n    width: 95%;\n    height: 85%;\n    max-height: none;\n  }\n\n  .chatbot-icon-container {\n    bottom: 90px;\n  }\n}\n\n/* Chatbot Sidebar Styles */\n.chatbot-menu-btn {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background 0.2s;\n  margin-right: 12px;\n}\n\n.chatbot-menu-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.chatbot-sidebar {\n  position: absolute;\n  top: 64px;\n  /* Approximate header height */\n  left: 0;\n  bottom: 0;\n  width: 260px;\n  background: #071414;\n  border-right: 1px solid rgba(0, 224, 197, 0.2);\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.5);\n  overflow-y: auto;\n  transform: translateX(-100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.chatbot-sidebar.open {\n  transform: translateX(0);\n}\n\n.chatbot-sidebar-backdrop {\n  position: absolute;\n  top: 64px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(2px);\n  z-index: 18;\n  animation: fadeIn 0.25s ease;\n}\n\n@keyframes slideRight {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.new-chat-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-bottom: 24px;\n}\n\n.new-chat-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.chatbot-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow-y: auto;\n}\n\n.history-section-title {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n  margin-bottom: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding-left: 8px;\n}\n\n.history-loading {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.5);\n  text-align: center;\n  margin-top: 20px;\n}\n\n.history-item {\n  padding: 10px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.history-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.history-item.active {\n  background: rgba(0, 224, 197, 0.15);\n  border-left: 3px solid #00e0c5;\n}\n\n.history-item-title {\n  font-size: 14px;\n  color: #e0e0e0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n}\n\n.history-item-date {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n/* Scrollbar for sidebar */\n.chatbot-sidebar::-webkit-scrollbar {\n  width: 5px;\n}\n\n.chatbot-sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chatbot-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n}\n\n/* Generating Sub-Ballots Animation */\n.subballot-generating {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  border: 1px solid rgba(0, 224, 197, 0.2);\n  margin-top: 16px;\n  animation: fadeIn 0.4s ease;\n}\n\n.generating-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid rgba(0, 224, 197, 0.3);\n  border-radius: 50%;\n  border-top-color: #00e0c5;\n  animation: spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n.subballot-generating p {\n  color: #00e0c5;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.7;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0.7;\n  }\n}\n\n\n/* Generating Sub-Ballots Animation */\n.subballot-generating {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  border: 1px solid rgba(0, 224, 197, 0.2);\n  margin-top: 16px;\n  animation: fadeIn 0.4s ease;\n}\n\n.generating-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid rgba(0, 224, 197, 0.3);\n  border-radius: 50%;\n  border-top-color: #00e0c5;\n  animation: spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n.subballot-generating p {\n  color: #00e0c5;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.7;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0.7;\n  }\n}\n\n/* Validation Save Error Message */\n.ballot-edit-actions-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.save-error-message {\n  color: #ff5252;\n  margin-bottom: 12px;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: center;\n  background: rgba(255, 82, 82, 0.1);\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 82, 82, 0.2);\n  width: 100%;\n  animation: fadeIn 0.3s ease;\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n.validate-option-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n}\n\n.validate-option-status.loading {\n  color: #00e0c5;\n}\n\n.validate-option-status.success {\n  color: #4caf50;\n}\n\n.validate-option-status.error {\n  color: #f44336;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
